import React from 'react';
import { ProductListSortOption, parseProductListSortOption } from '../../../../utils/productListSort';
import { CusProductListProductListSortProps } from '../../cus-product-list.data';

const SELECT_ID = 'bs-product-list-sort-select';

export default function ProductListSort({ props, currentSort, onSortChange }: CusProductListProductListSortProps) {
    const { sortByDropdownLabel, sortRecommendedText, sortByOptionPriceAsc, sortByOptionPriceDesc } = props.resources;
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onSortChange(parseProductListSortOption(event.target.value));
    };

    const options: { value: ProductListSortOption; label: string }[] = [
        { value: 'recommended', label: sortRecommendedText },
        { value: 'price-asc', label: sortByOptionPriceAsc },
        { value: 'price-desc', label: sortByOptionPriceDesc }
    ];

    return (
        <div className='bs-product-list__sort'>
            <label className='bs-product-list__sort__label' htmlFor={SELECT_ID}>
                {sortByDropdownLabel}
            </label>
            <select id={SELECT_ID} className='bs-product-list__sort__select' value={currentSort} onChange={handleChange}>
                {options.map(opt => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
            <span className='bs-product-list__sort__chevron' aria-hidden='true' />
        </div>
    );
}
